import { render } from "./CreateRouter.vue?vue&type=template&id=33eb47f6"
import script from "./CreateRouter.vue?vue&type=script&lang=js"
export * from "./CreateRouter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__